
import axios from "axios";
import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from "react-bootstrap/Spinner";
import InputLabel from '@mui/material/InputLabel';
import { Icon } from "@iconify/react";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { Button, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Box } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Typography from '@mui/material/Typography';
import * as moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import settings from "../helpers/Settings";
let { KayanURL } = settings;

class Payment extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount = async () => {
    };
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ RequestSent: true, Response: false });
        let paymentNotceResponse = await axios.post(
            "http://141.147.130.248:4000/api/KSA/RCM/request",
            // KayanURL + "api/KSA/RCM/request",
            {
                apiToken: "token",
                requestType: "7",
                providerID: "10000300178702",
                paymentReconcilationIdentifier: this.state.paymentReconsiliation,
                paymentDate: this.state.paymentDate,
                amount: this.state.amount,
                paymentStatus: this.state.paymentStatus,
            }
        );

        if (paymentNotceResponse) {
            this.setState({
                RequestSent: false,
                Response: true,
            });
            let { data } = paymentNotceResponse;
            if (data) {
                let { success, response, error, BundleID } = data;
                if (BundleID) {
                    this.setState({ BundleID });
                }
                if (success) {
                    let res = JSON.parse(response);
                    this.setState({ res, success });
                    let { entry } = res
                    if (entry && entry.length > 0) {
                        let messageHeader = entry.filter((element) => {
                            return element["resource"]["resourceType"] == "MessageHeader";
                        });
                        if (messageHeader && messageHeader.length > 0) {
                            let { code } = messageHeader[0]["resource"]["eventCoding"]
                            let { identifier } = messageHeader[0]["resource"]["response"]
                            let responseCode = messageHeader[0]["resource"]["response"]["code"]
                            this.setState({ ksaMessageEvents: code, responseIdentifier: identifier, responseCode })
                            console.log(code, identifier, responseCode)
                        }
                    }
                } else {
                    this.setState({ error });
                    console.log(error);
                }
            }
        }
    };
    HandleDateChange = (e) => {
        let date = moment(e.value.$d).format('YYYY-MM-DD')
        this.setState({ [e.name]: date })
    }
    HandleInputTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };
    render() {
        let { RequestSent, Response, success } = this.state;
        return (
            <>
                <Box height={60} />
                <div style={{
                    textAlign: "left",
                    boxShadow: "1px solid grey",
                    boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                    borderRadius: "10px",
                    paddingBottom: "20px",
                }}>
                    <Container style={{ width: "50%" }}>
                        <Row style={{ padding: "40px" }}>
                            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ marginBottom: "20px" }}>
                                Payment
                            </Typography>
                            <FormControl fullWidth sx={{ mb: 3 }} >
                                <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                    inputProps={{ sx: { padding: "11px" } }} required name="paymentReconsiliation" label="Payment Reconcilation Identifier" variant="outlined" onChange={this.HandleInputTextChange} />

                            </FormControl>
                            <FormControl fullWidth sx={{ mb: 3, }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs} >

                                    <DatePicker
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                height: "12px",
                                            },
                                            ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                                                fontSize: 'small',
                                            },
                                        }}
                                        name="paymentDate"
                                        label="Payment Date"
                                        onChange={(date) => this.HandleDateChange({ name: "paymentDate", value: date })} />
                                </LocalizationProvider>
                            </FormControl>
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                    inputProps={{ sx: { padding: "11px" } }} required type='number' name='amount' label="Payment Amount" variant='outlined' onChange={this.HandleInputTextChange} />
                            </FormControl>
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <InputLabel id="paymentstatus" style={{ fontSize: "small" }}>Payment Status</InputLabel>
                                <Select
                                    required
                                    labelId="paymentstatus"
                                    name="paymentStatus"
                                    label="Payment Status"
                                    style={{ height: "45px" }}
                                    onChange={this.HandleInputTextChange}
                                >
                                    <MenuItem value="cleared" style={{ fontSize: "small" }}>cleared</MenuItem>

                                </Select>
                            </FormControl>
                            <Button variant="contained" style={{ backgroundColor: "rgb(97 110 120", width: "150px" }}
                                onClick={(e) => this.handleSubmit(e)}
                            >Submit</Button>

                        </Row>

                    </Container>
                    
                    <div style={{ textAlign: "center",marginTop:"25px" }}>
                        {this.state.BundleID ? (<Typography id="modal-modal-title"
                         variant="h6" component="h2" 
                         style={{ textAlign: "center",
                          marginTop: "5px",
                          marginBottom:"10px", 
                          fontSize: "small" }}>
                            The request bundle ID is: {this.state.BundleID}
                            </Typography>) : null}
                        </div>
                        {RequestSent && !Response ? (   
                <div style={{textAlign:"center",marginTop:"10px"}}>
                <Spinner animation="border" variant="success"  />
                  </div>

              ) : !success ? (
                <h5 style={{ color: "red" }}>{this.state.error}</h5>
              ) :  success  ? (
                <div style={{ textAlign: "center" }}>
                 
                 
                    <div style={{ width: "98%", overflowX: "scroll" }}>
                        <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table"

                      >
                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                          <TableRow style={{ textAlign: 'center' }}>
                            <TableCell align="center">ksaMessageEvents</TableCell>
                            <TableCell align="center">responseIdentifier</TableCell>
                            <TableCell align="center">responseCode</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow style={{ textAlign: 'center' }}>
                                <TableCell align="center">
                                {this.state.ksaMessageEvents}
                                </TableCell>
                                <TableCell align="center">
                                {this.state.responseIdentifier}
                                </TableCell>
                                <TableCell align="center">
                                {this.state.responseCode}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                      </Table>
                      </TableContainer>
                    </div>
                  
                </div>
              ) : null}
                </div>
            </>
        );
    }
}

export default Payment;